<div>
    <table>
        <thead>
                <th *ngIf="showFacilities" class="large-filter-column">Facilities</th>
                <th *ngIf="showCostCenters" class="large-filter-column" >Cost Centers</th>
                <th *ngIf="showVarianceType" class="large-filter-column" >Variance Type</th>
                <th *ngIf="showCensusTypes" class="large-filter-column">Census Types</th>
                <th *ngIf="showShiftBlocks" class="large-filter-column">Shift Blocks</th>
                <th *ngIf="showPeriodEndDateSelection" class="large-filter-column">Period Ending</th>
                <th *ngIf="showDateRange" class="small-filter-column">Date Range</th>
                <th *ngIf="showViews" class="small-filter-column">View</th>
        </thead>
        <tr>
            <td *ngIf="showFacilities">
                <ul class="multi-select" #facilityFilters>
                    <ng-container *ngIf="!isSingleCostCenterSelection">
                        <li class="checkbox" *ngFor="let facility of facilities">
                            <input type="checkbox" [(ngModel)]="facility.checked" (change)="facilitiesChanged()"/>
                            {{facility.name}}
                        </li>
                    </ng-container>
                    <ng-container *ngIf="isSingleCostCenterSelection">
                        <li *ngFor="let facility of facilities">
                            <input type="radio" name="facility" id="{{facility.id}}" [(ngModel)]="facility.value"
                                value="{{facility.name}}" (change)="facilityChanged(facility)" />
                            {{facility.name}}
                        </li>
                    </ng-container>
                </ul>
            </td>
  
            <td *ngIf="showCostCenters">
                <ul class="multi-select">
                    <ng-container *ngIf="!isSingleCostCenterSelection">
                        <li class="checkbox" *ngFor="let costCenter of visibleCostCenters" (change)="costCentersChanged()">
                            <input type="checkbox" [(ngModel)]="costCenter.checked" />
                            {{costCenter.name}}
                        </li>
                    </ng-container>
                    <ng-container *ngIf="isSingleCostCenterSelection">
                        <li class="radio" *ngFor="let costCenter of visibleCostCenters" (change)="costCenterChanged(costCenter)">
                            <input type="radio" name="costcenter" id="{{costCenter.id}}" value="{{costCenter.name}}"
                                [(ngModel)]="costCenter.value" />
                            {{costCenter.name}}
                        </li>
                    </ng-container>
                </ul>
            </td>
            <td *ngIf="showVarianceType">
                <ul class="multi-select" >
                  <li *ngFor="let item of varianceTypes">
                    <input type="radio" value="{{item}}" name="VarianceType"  [(ngModel)]="varianceType" />
                    {{item}} 
                  </li>
                </ul>
              </td>
            <td *ngIf="showCensusTypes">
                <ul class="multi-select" #CensusType >
                    <li>
                        <input type="radio" value="averageCensus" name="CensusType" [(ngModel)]="censusType" />
                        Average Census
                    </li>
                    <li>
                        <input type="radio" value="midnightCensus" [disabled]="!showMidnightCensus" name="CensusType" [(ngModel)]="censusType" />
                        Midnight Census
                    </li>
  
                </ul>
            </td>
            
            <td *ngIf="showShiftBlocks">
                <ul class="multi-select">
                    <li class="checkbox" *ngFor="let shiftBlock of visibleShiftBlocks">
                        <input type="checkbox" [(ngModel)]="shiftBlock.checked" />
                        {{shiftBlock.name}}
                    </li>
                </ul>
            </td>
  
            
            <td *ngIf="showPeriodEndDateSelection">
              <ul class="multi-select">
                  <li class="checkbox" *ngFor="let periodEndDate of visiblePeriodEnd">
                      <input type="checkbox" [(ngModel)]="periodEndDate.checked" />
                      {{periodEndDate.name}}
                  </li>
              </ul>
          </td>
  
            <td *ngIf="showDateRange">
                <ul class="multi-select">
                    <li>
                        <label>Start Date</label>
                        <input type="date" id="dateFrom" [(ngModel)]="dateFrom"/>
                    </li>
                    <li>
                        <label>End Date</label>
                        <input type="date"  id="dateTo"  [(ngModel)]="dateTo"/>
                    </li>
                </ul>
            </td>
            <td *ngIf="showPeriodEnding">        
                <label>Period Ending</label>
                <input type="date" [(ngModel)]="periodEnd"/>
            </td>            
            <td *ngIf="showViews">
                <ul class="multi-select" #View>
                  <li *ngFor="let item of views">
                    <input type="radio" value="{{item}}" name="Views" [checked]='item == defaultView' (change)="viewByChanged($event)" />
                    {{item}} 
                  </li>
                </ul>
              </td>
            <td class="button-filter-column">
                <ul>
                    <li><button class="compact" role="button" (click)="resetFilters()">Reset</button></li>
                    <li><button class="compact" role="button" (click)="applyFilters()">Apply</button></li>
                </ul>
            </td>
        </tr>
    </table>
  </div>
  